import { ReactNode } from 'react';
import { ReactComponent as PreviousPageIcon } from '../../assets/icons/previous-page.svg';
import { ReactComponent as PreviousPageIconDisabled } from '../../assets/icons/previous-page-disabled.svg';
import { ReactComponent as NextPageIcon } from '../../assets/icons/next-page.svg';
import { ReactComponent as NextPageIconDisabled } from '../../assets/icons/next-page-disabled.svg';
import Hr from '../../assets/icons/hr.svg';
import { useStyles } from './PagesNavigator.styles';
import CancelIcon from '@material-ui/icons/Cancel';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { IconButton } from '@mui/material';
import { fill, fillOpacity } from '../../utils/contrastSvgAttributes';

interface PagesNavigatorProps {
  totalPages: number | undefined;
  currentPage: number | undefined;
  setCurrentPage: (page: number) => void;
  disabled?: boolean;
}

export const PagesNavigator: React.FC<PagesNavigatorProps> = (props) => {
  const classes = useStyles();

  const prevButtonEnabled = !props.disabled && props.currentPage !== 1;
  const nextButtonEnabled = !props.disabled && props.currentPage !== props.totalPages;

  return (
    <div style={{ display: 'flex' }}>
      <TooltipOne title={prevButtonEnabled ? 'Poprzednia strona' : ''} placement="top">
        <IconButton disableRipple style={{ padding: '12px' }} onClick={() => {
          if (prevButtonEnabled) {
            props.currentPage && props.setCurrentPage(props.currentPage - 1);
          } else return;
        }}>
          {prevButtonEnabled ? (
            <PreviousPageIcon fill={fill} title="ikona poprzednia strona" />) :
            (<>
              <CancelIcon className={classes.disabledAction} />
              <PreviousPageIconDisabled fill={fill} fillOpacity={fillOpacity} style={{ cursor: 'not-allowed' }} title="ikona poprzednia strona" />
            </>
            )}
        </IconButton>
      </TooltipOne>
      <TooltipOne title={nextButtonEnabled ? 'Następna strona' : ''} placement="top">
        <IconButton disableRipple style={{ padding: '12px' }} onClick={() => {
          if (nextButtonEnabled) {
            props.currentPage && props.setCurrentPage(props.currentPage + 1);
          } else return;
        }}>
          {nextButtonEnabled ? (
            <NextPageIcon fill={fill} title="ikona następna strona" />) :
            (
              <>
                <CancelIcon className={classes.disabledAction} />
                <NextPageIconDisabled fill={fill} fillOpacity={fillOpacity} style={{ cursor: 'not-allowed' }} title="ikona następna strona" />
              </>)}
        </IconButton>
      </TooltipOne>
      <div className={classes.cardPreviewMenuPages}>
        <div
          className={classes.cardPreviewMenuCurrentPage}
          style={{ color: props.disabled ? '#757575' : undefined }}
        >
          {props.currentPage}
        </div>
        <div
          className={classes.cardPreviewMenuTotalPages}
          style={{ color: props.disabled ? '#757575' : undefined }}
        >
          /{props.totalPages}
        </div>
      </div>
    </div>
  );
};
